// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
}

.analytics-page-main {
  position: relative;
  padding-bottom: 50px;
  width: 100vw;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.analytics-page-main .title-wrap {
  padding: 45px 138px;
  width: 100%;
  max-width: 1512px;
  box-sizing: border-box;
  margin: 0 auto; /* Added to center the box */

}

.analytics-page-main .title {
  color: #000;
  font-family: Georgia;
  font-size: 50.4px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
}

.analytics-page-main .text {
  color: #000;
  font-family: Inter;
  font-size: 18.9px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}

/* Add unique namespace to all selectors */
.congress-bill-split {
  width: 100%;
  max-width: 1220px;

  height: auto;
  min-height: 900px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 5px;
  box-sizing: border-box;
  margin: 0 auto; /* Changed from 0 to 0 auto */

  flex-direction: column; /* Added */
  align-items: center; /* Added */
}


.majority-alignment {
  width: 100%;
  max-width: 1220px;
  height: auto;
  min-height: 900px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 18px;
  box-sizing: border-box;
  margin: 0 auto; /* Changed from 0 to 0 auto */
  display: flex; /* Added */
  flex-direction: column; /* Added */
  align-items: center; /* Added */
}

.graphs-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  flex: 1 1;
}

.chart-selector-container {
  width: 100vw;
  margin: 0;
  box-sizing: border-box;
}

/* Update mobile styles */
@media (max-width: 768px) {
  .analytics-page-main {
    padding-bottom: 20px;
  }

  .analytics-page-main .title-wrap {
    padding: 12px;
  }

  .analytics-page-main .title {
    font-size: 24px;
  }

  .analytics-page-main .text {
    font-size: 14px;
  }

  .graphs-container {
    width: 100%;
    padding: 0;
  }

  .chart-selector-container {
    padding: 0 4px;
  }
}

/* Update the graphs container to be more compact on mobile */
.graphs-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  flex: 1 1;
}

.chart-selector-container {
  width: 100%;
  max-width: 1210px;
  margin: 0 auto;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Analytics/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,cAAc,EAAE,4BAA4B;;AAE9C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,iBAAiB;;EAEjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,sBAAsB;EACtB,cAAc,EAAE,6BAA6B;;EAE7C,sBAAsB,EAAE,UAAU;EAClC,mBAAmB,EAAE,UAAU;AACjC;;;AAGA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,cAAc,EAAE,6BAA6B;EAC7C,aAAa,EAAE,UAAU;EACzB,sBAAsB,EAAE,UAAU;EAClC,mBAAmB,EAAE,UAAU;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".analytics-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100vw;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.analytics-page-main {\n  position: relative;\n  padding-bottom: 50px;\n  width: 100vw;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.analytics-page-main .title-wrap {\n  padding: 45px 138px;\n  width: 100%;\n  max-width: 1512px;\n  box-sizing: border-box;\n  margin: 0 auto; /* Added to center the box */\n\n}\n\n.analytics-page-main .title {\n  color: #000;\n  font-family: Georgia;\n  font-size: 50.4px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-align: left;\n}\n\n.analytics-page-main .text {\n  color: #000;\n  font-family: Inter;\n  font-size: 18.9px;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n}\n\n/* Add unique namespace to all selectors */\n.congress-bill-split {\n  width: 100%;\n  max-width: 1220px;\n\n  height: auto;\n  min-height: 900px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 24px 5px;\n  box-sizing: border-box;\n  margin: 0 auto; /* Changed from 0 to 0 auto */\n\n  flex-direction: column; /* Added */\n  align-items: center; /* Added */\n}\n\n\n.majority-alignment {\n  width: 100%;\n  max-width: 1220px;\n  height: auto;\n  min-height: 900px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 24px 18px;\n  box-sizing: border-box;\n  margin: 0 auto; /* Changed from 0 to 0 auto */\n  display: flex; /* Added */\n  flex-direction: column; /* Added */\n  align-items: center; /* Added */\n}\n\n.graphs-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.chart-selector-container {\n  width: 100vw;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* Update mobile styles */\n@media (max-width: 768px) {\n  .analytics-page-main {\n    padding-bottom: 20px;\n  }\n\n  .analytics-page-main .title-wrap {\n    padding: 12px;\n  }\n\n  .analytics-page-main .title {\n    font-size: 24px;\n  }\n\n  .analytics-page-main .text {\n    font-size: 14px;\n  }\n\n  .graphs-container {\n    width: 100%;\n    padding: 0;\n  }\n\n  .chart-selector-container {\n    padding: 0 4px;\n  }\n}\n\n/* Update the graphs container to be more compact on mobile */\n.graphs-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.chart-selector-container {\n  width: 100%;\n  max-width: 1210px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
